import { NoSSR } from '@ui/components/NoSSR';
import { getChainInfo } from '@ui/constants/chain';
import { useDataChainStore } from '@ui/hooks/datachain';
import { Button } from '@ui/lib/park/ui/button';
import { useTranslation } from 'next-i18next';
import { styled } from 'styled-system/jsx';
import { useAccount } from 'wagmi';

import { NetworkSwitchModal } from './NetworkSwitchModal';

export const DataNetworkSwitch = () => {
  const { dataChain, setDataChain } = useDataChainStore();
  const { t } = useTranslation();
  const { isConnected } = useAccount();

  if (isConnected) return null;

  return (
    <NoSSR>
      <NetworkSwitchModal
        switchChain={(c) => setDataChain(c)}
        title={t('common.Choose Network')}
      >
        <Button
          variant="primary"
          gap={2}
          h="8"
          px={2}
          py={1}
          position="relative"
          data-cy="NetworkSwitchButton"
          data-cy-value={dataChain}
        >
          <styled.img src={getChainInfo(dataChain).icon} boxSize="4" />
        </Button>
      </NetworkSwitchModal>
    </NoSSR>
  );
};
